<div
  class="flex items-center justify-center rounded-2xl bg-white p-10 shadow-sm"
>
  <div
    class="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-indigo-500"
  ></div>
  <span class="ml-3 text-slate-600 font-medium">Loading survey...</span>
</div>
